export default __webpack_public_path__ + "static/media/favicon.6897d970.ico";